import { render } from "./SidenavList.vue?vue&type=template&id=78e3fae8"
import script from "./SidenavList.vue?vue&type=script&lang=js"
export * from "./SidenavList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/Sidenav/SidenavList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "78e3fae8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('78e3fae8', __exports__)) {
    api.reload('78e3fae8', __exports__)
  }
  
  module.hot.accept("./SidenavList.vue?vue&type=template&id=78e3fae8", () => {
    api.rerender('78e3fae8', render)
  })

}


export default __exports__